import type { IEventStore } from '@/types';

/**
 * Persists buffered events to sessionStorage so they survive same-tab
 * navigations and can be replayed after a page unload/reload cycle.
 *
 * Failures are swallowed intentionally — storage quota exhaustion should
 * never crash the recorder.
 */
export class SessionStorageEventStore implements IEventStore {
  constructor(private readonly key: string = 'cobrowsing_pendingEvents') {}

  private get store(): Storage | null {
    return typeof sessionStorage !== 'undefined' ? sessionStorage : null;
  }

  load(): unknown[] {
    try {
      const raw = this.store?.getItem(this.key);
      if (!raw) return [];
      return JSON.parse(raw) as unknown[];
    } catch {
      return [];
    }
  }

  save(events: unknown[]): void {
    try {
      this.store?.setItem(this.key, JSON.stringify(events));
    } catch {
      // Quota exceeded — best effort, carry on.
    }
  }

  clear(): void {
    try {
      this.store?.removeItem(this.key);
    } catch {
      // ignore
    }
  }
}
